/**
 * @file The Dialog service
 * @author Heino Lenting
 */
import { AsyncSubject } from 'rxjs';
/**
 * Class for the dialog service
 */
var DialogService = /** @class */ (function () {
    function DialogService() {
    }
    /**
     * Create a dialog
     * @param subject The subject of the dialog
     * @param message The message of the dialog
     * @returns The Observable is returned to make the choice of the user observable
     */
    DialogService.prototype.createDialog = function (subject, message, buttonText) {
        var self = this;
        // If dialog is unhandled, cancel it (We don't want to have multiple dialogs because that's stupid)
        if (this.observer !== undefined) {
            this.observer.complete();
        }
        // Save the subject
        this.subject = subject;
        // Save the message
        this.message = message;
        // Save the button text
        this.buttonText = buttonText;
        this.observer = new AsyncSubject();
        return this.observer;
        // // Create observable
        // return Observable.create(observer => {
        //     self.observer = observer;
        // });
    };
    Object.defineProperty(DialogService.prototype, "inProgress", {
        /**
         * Gets the observable of the current dialog.
         * @readonly
         * @type {Observable<boolean>}
         */
        get: function () {
            return this.observer;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Is there a dialog in the service
     * @returns Returns if a dialog exists
     */
    DialogService.prototype.hasDialog = function () {
        return (this.observer !== undefined);
    };
    /**
     * Get access to the subject of the dialog
     * @returns The subject of the dialog
     */
    DialogService.prototype.getSubject = function () {
        return (this.subject) ? this.subject : '';
    };
    /**
     * Get access to the message of the dialog
     * @returns The message of the dialog
     */
    DialogService.prototype.getMessage = function () {
        return (this.message) ? this.message : '';
    };
    /**
     * Get access to the text of the button
     * @returns The text of the button
     */
    DialogService.prototype.getButtonText = function () {
        return (this.buttonText) ? this.buttonText : '';
    };
    /**
     * Handles the choice of the user in the dialog
     */
    DialogService.prototype.next = function (value) {
        if (this.observer) {
            this.observer.next(value);
            this.observer.complete();
            this.observer = undefined;
        }
    };
    return DialogService;
}());
export { DialogService };
